<script setup>
// Disque d'icône de la bible. « solid » : couleur pleine, icône blanche (jaune compris).
// « soft » : fond pâle, icône de la couleur. Pop (chippop 0,3 s) au montage, décalable.
import { BRAND } from '../../lib/brandTones';
const props = defineProps({
  color: { type: String, default: 'yellow' },
  variant: { type: String, default: 'solid' },
  size: { type: String, default: 'lg' },
  shape: { type: String, default: 'round' },
  pop: { type: Boolean, default: true },
  delay: { type: Number, default: 0 },
});
const sizes = { sm: 'w-10 h-10 [&>svg]:w-5 [&>svg]:h-5', md: 'w-12 h-12 [&>svg]:w-6 [&>svg]:h-6', lg: 'w-14 h-14 [&>svg]:w-7 [&>svg]:h-7', xl: 'w-16 h-16 [&>svg]:w-8 [&>svg]:h-8' };
</script>

<template>
  <div
    class="inline-flex items-center justify-center shrink-0"
    :class="[
      sizes[size],
      shape === 'round' ? 'rounded-full' : 'rounded-2xl',
      variant === 'solid' ? `${BRAND[color].solid} ${BRAND[color].on} shadow-sm` : `${BRAND[color].soft} ${BRAND[color].text}`,
      pop ? 'brand-pop' : '',
    ]"
    :style="pop && delay ? { animationDelay: `${delay}ms` } : undefined"
  >
    <slot />
  </div>
</template>
